import "./App.css";
import { Box, Grid, Typography, styled } from "@mui/material";
import { StyledLogoWrapper } from "components/styles";
import Stepper from "pages/Stepper";
import ordersLogo from "assets/img/ordersLogo.png";
import { useMatchMobile, useMatchTablet } from "hooks/useMatchMobile";
import { useNavigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const isKiosk = () => {
  // Your logic to detect kiosk mode
  //return window.navigator.userAgent.includes("Kiosk"); // just an example
  return false;
};
const theme = createTheme({
  palette: {
    primary: {
      main: "#ff6b00",
    },
  },
  header: {
    logo: ordersLogo,
    logoalt: "Orders.co Logo",
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          ...(isKiosk() && {
            fontSize: "2rem", // or whatever size you want
            padding: "16px 32px", // adjust padding as needed
          }),
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          ...(isKiosk() && {
            fontSize: "2rem", // adjust as per your need
          }),
        },
        input: {
          ...(isKiosk() && {
            padding: "10px", // adjust padding as needed
          }),
        },
      },
    },
  },
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: "#000",
  fontSize: "72px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "72px",
  textAlign: "left",
}));

function App() {
  const navigate = useNavigate();
  const { isMatchMobile } = useMatchMobile();
  return (
    <ThemeProvider theme={theme}>
      <Box className="App">
        <Grid container sx={{ height: "100vh" }}>
          {!isMatchMobile && (
            <Grid
              item
              md={12}
              lg={6}
              sx={{
                background: "#EBEEF3",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
                display: "flex",
                position: "relative",
              }}
            >
              <StyledLogoWrapper
                sx={{ position: "absolute", top: "24px", left: "24px" }}
                onClick={() => navigate("/")}
              >
                <img
                  src={theme.header.logo}
                  alt={theme.header.logoalt}
                  style={{ width: "auto", height: "48px" }}
                />
              </StyledLogoWrapper>
              <Box
                sx={{
                  maxWidth: "357px",
                }}
              >
                <StyledTitle>Review and edit your info</StyledTitle>
              </Box>
            </Grid>
          )}

          <Grid item lg={6} md={12} xs={12} sm={12}>
            <Box
              sx={{ display: "flex", flexDirection: "column", height: "87vh" }}
            >
              <Box
                sx={{
                  // background: "#333",
                  color: "#fff",
                  padding: "1rem",
                  flexShrink: 0,
                  height: "48px",
                }}
              >
                {isMatchMobile && (
                  <StyledLogoWrapper onClick={() => navigate("/")}>
                    <img
                      src={theme.header.logo}
                      alt={theme.header.logoalt}
                      style={{ width: "auto", height: "48px" }}
                    />
                  </StyledLogoWrapper>
                )}
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  overflowY: "auto",
                }}
              >
                <Stepper />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      //{" "}
    </ThemeProvider>
  );
}

export default App;
